import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <main id="main-content" tabIndex={-1} className="bg-brand-off-white px-6 py-24 text-center">
      <p className="mb-3 font-semibold text-brand-warm-gray">404</p>
      <h1 className="mb-5 font-serif text-4xl font-bold text-brand-navy">Page not found</h1>
      <p className="mx-auto mb-8 max-w-lg text-brand-warm-gray">The page may have moved. We can still help with your heating and cooling needs.</p>
      <div className="flex flex-wrap justify-center gap-4">
        <Link to="/" className="rounded-lg bg-brand-navy px-6 py-3 font-semibold text-white">Back to home</Link>
        <Link to="/contact" className="rounded-lg border border-brand-navy px-6 py-3 font-semibold text-brand-navy">Contact our team</Link>
      </div>
    </main>
  );
}
